// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"f5ef8f9b","351":"8f333e6d","377":"7b98c648","427":"7996a156","722":"594a93fe","735":"0b2abcb9","966":"c9c00225","973":"f3a45627"}[chunkId] + ".chunk.js";
};